// 微信api
const WeixinApi = {
  // 分享
  share: function (options, successcb, errorcb) {
    var setShare = function () {
      if (options.description && options.description.length > 30) {
        options.description = options.description.substr(0, 27) + '...'
      }
      // webview 路径
      const miniPayPath = `/view/wxpay/h5/index`;
      // 要分享打开的 h5
      const targetH5url = options.webpageURL;
      console.log('---->targetH5url', targetH5url)
      // 当前 h5 及未来会跳转的 h5 不会包含同步登录态、不涉及支付时
      // ! 不经过中转页，不会有小程序侧 cookie 信息
      const path = `${miniPayPath}?sendfrom=wechat&returnUrl=${encodeURIComponent(targetH5url)}`;
      const messageData = {
        agreement: `makeShareInfo`,
        data: {
          title: options.title,
          imageUrl: options.iconURL,
          path: path
        }
      }
      window.__MiniProgramInteraction.postMessage(messageData)
      console.log('---->messageData', messageData)
    }
    window.__MiniProgramInteraction.startShare()
    setShare()
  }

}
export default WeixinApi



// WEBPACK FOOTER //
// ./src/environment/weixinMini_api.js